import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import AboutUsReducer from "./reducers/aboutUsReducer";
import CollaboratorReducer from "./reducers/collaboratorReducer";
import GroupReducer from "./reducers/groupReducer";
import HomeReducer from "./reducers/homeReducer";
import LoginReducer from "./reducers/loginReducer";
import MiniTitleReducer from "./reducers/miniTitleReducer";

const rootReducer = combineReducers({
  aboutUs: AboutUsReducer,
  collaborator: CollaboratorReducer,
  group: GroupReducer,
  home: HomeReducer,
  login: LoginReducer,
  miniTitle: MiniTitleReducer
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
